import { render } from "./LoginPage.vue?vue&type=template&id=74bd015a&ts=true"
import script from "./LoginPage.ts?vue&type=script&lang=ts"
export * from "./LoginPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__